import authHeader from 'srcReact/helpers/auth-header'
import axios from 'axios'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const groupService = {
  cancelInvitation,
  sendInvites,
  resendInviteAll,
  getWorkplacesByOrgId,
  createGroup,
  editGroup,
  getGroupDetailById,
  joinGroup,
  acceptInvitation,
  declineInvitation
}

let cancel

function getGroupDetailById(groupId, scope) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  const param = scope && scope.length > 0 ? `&scope=${scope}` : ''
  return doRequestAxios(`/v2/group/information?group_id=${groupId}${param}`, requestOptions)
}
function createGroup(workplaceId, group) {
  group.location = JSON.stringify(group.location)
  const requestOptions = {
    headers: authHeader(),
    method: 'POST',
    data: { ...group }
  }
  return doRequestAxios(`/v2/group/creation/add?workplace_id=${workplaceId}`, requestOptions)
}

function editGroup(groupId, group) {
  group.location = JSON.stringify(group.location)
  const requestOptions = {
    headers: authHeader(),
    method: 'PUT',
    data: { ...group }
  }

  return doRequestAxios(`/v2/group/edition/update?group_id=${groupId}`, requestOptions)
}

function getWorkplacesByOrgId(organizationId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return doRequestAxios(`/v2/group/creation/workplaces?organization_id=${organizationId}`, requestOptions)
}

function sendInvites(groupId, usersId, message) {
  const params = {
    group_id: groupId,
    users_id: usersId,
    message
  }

  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios(`/v2/group/invitation/send`, requestOptions)
}

function cancelInvitation(group_id, user_id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/group/invitation/remove?group_id=${group_id}&user_id=${user_id}`, requestOptions)
}

function resendInviteAll(group_id) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }

  return doRequestAxios(`/v2/group/invitation/resend-all?group_id=${group_id}`, requestOptions)
}

function joinGroup(groupId, invitedBy) {
  const param = invitedBy && invitedBy.length > 0 ? `&invited_by=${invitedBy}` : ''
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/group/member/add?group_id=${groupId}${param}`, requestOptions)
}

function acceptInvitation(groupId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/group/invitation/accept?group_id=${groupId}`, requestOptions)
}
function declineInvitation(groupId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/group/invitation/refuse?group_id=${groupId}`, requestOptions)
}
